<script lang="ts">
	import ClockIcon from "@lucide/svelte/icons/clock";
	import HomeIcon from "@lucide/svelte/icons/home";
	import DollarSignIcon from "@lucide/svelte/icons/dollar-sign";
	import Section from "#lib/web-ui/primitives/section.svelte";
	import { getTemplateContext } from "../template-context.svelte";

	const templateContext = getTemplateContext();

	const features = [
		{
			icon: ClockIcon,
			title: "Fast and Flexible Closings",
			description:
				"Close on your timeline, whether you need to sell quickly or prefer a more extended timeline."
		},
		{
			icon: HomeIcon,
			title: "No Repairs or Cleanup",
			description:
				"Sell your property as-is, regardless of condition. No need for costly repairs, renovations, or deep cleaning."
		},
		{
			icon: DollarSignIcon,
			title: "Transparent Process",
			description:
				"What we offer is what you get. No commissions, minimal closing costs, and no unexpected fees eating into your proceeds."
		}
	];
</script>

<Section class="bg-foreground">
	<div class="mx-auto max-w-2xl sm:text-center">
		<h2 class="text-primary text-lg font-bold">Everything you need</h2>
		<p
			class="mt-2 text-4xl font-semibold tracking-tight text-pretty text-white sm:text-5xl sm:text-balance"
		>
			Why Sell Your Property With {templateContext.siteName}?
		</p>
		<p class="mt-6 text-lg text-gray-300">
			We make selling your property simple, stress-free, and tailored to your unique
			situation. We Buy Houses Fast For Cash in Any Condition Throughout {templateContext.serviceArea}.
		</p>
	</div>
	<div
		class="mt-6 grid max-w-2xl grid-cols-1 gap-x-6 gap-y-10 text-base/7 text-gray-300 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3 lg:gap-x-8 lg:gap-y-16"
	>
		{#each features as feature}
			<div
				class="hover:border-primary relative flex flex-row gap-4 rounded border-2 border-transparent p-6 transition-colors duration-300"
			>
				<div class="shrink-0 pt-1">
					<feature.icon class="text-primary h-6 w-6" />
				</div>
				<div class="flex flex-col">
					<span class="text-lg font-semibold">{feature.title}</span>
					<span class="mt-1 text-pretty text-gray-400">{feature.description}</span>
				</div>
			</div>
		{/each}
	</div>
</Section>
